'use client';

import { useUserNotificationsSubscription } from '@/hooks/useUserNotificationsSubscription';
import { useRainSubscription } from '@/hooks/useRainSubscription';
import { usePresenceHeartbeat } from '@/hooks/usePresenceHeartbeat';
import { useRushMidConfig } from '@/queries/useRushMidConfig';

export function GlobalSubscriptions() {
  useUserNotificationsSubscription();
  useRainSubscription();
  usePresenceHeartbeat();
  useRushMidConfig();
  return null;
}
